import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { LazyRenderedComponent } from '../../lazy-rendered-component/lazy-rendered-component';

const FooterWrapper = dynamic(() =>
  import('@sportsbook/common/components/footer/footer-wrapper/footer-wrapper').then(module => module.FooterWrapper)
);

export function FooterWrapperLoader({ loadImmediately }) {
  if (loadImmediately) {
    return <FooterWrapper />;
  }

  return (
    <LazyRenderedComponent className="sb-FooterWrapperLoader sb-Preloader">
      <FooterWrapper />
    </LazyRenderedComponent>
  );
}

FooterWrapperLoader.propTypes = {
  loadImmediately: PropTypes.bool,
};

FooterWrapperLoader.defaultProps = {
  loadImmediately: true,
};
